import $ from 'jquery';
import inView from 'in-view';

$(function() {
    // Triggers animation for different elements when in viewport
    inView('.block-cta')
        .on('enter', () => {
            $('.block-cta .icon').addClass('waving');
        })
        .on('exit', () => {
            $('.block-cta .icon').removeClass('waving');
        });
    inView('.btn-white')
        .on('enter', () => {
            $('.btn-white img').addClass('visible');
        })
        .on('exit', () => {
            $('.btn-white img').removeClass('visible');
        });
    inView('.contact-form-title')
        .on('enter', () => {
            $('.contact-form-title img').addClass('visible');
        })
        .on('exit', () => {
            $('.contact-form-title img').removeClass('visible');
        });
    inView('.block-floating-cta')
        .on('enter', () => {
            $('.block-floating-trigger img').addClass('waving');
        })
        .on('exit', () => {
            $('.block-floating-trigger img').removeClass('waving');
        });
});
